import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip, Typography } from '@mui/material'
import {
  CheckCircle,
  Edit,
  HourglassTop,
  Lock,
  Pending,
  Receipt,
  WatchLater,
  Work,
} from '@vedmarket/ui-kit'
import { APPLICATION_STATUS, COLORS } from 'config/constants'
import { getApplicationStatusLabel } from './status-label'

const STATUS_PRESENTATION = {
  [APPLICATION_STATUS.PREPARING]: { Icon: Edit, color: COLORS.WARNING },
  [APPLICATION_STATUS.AWAITING_CLIENT]: { Icon: WatchLater, color: COLORS.WARNING },
  [APPLICATION_STATUS.PREPARATION_COMPLETE]: { Icon: CheckCircle, color: COLORS.GREEN },
  [APPLICATION_STATUS.AWAITING_EXECUTOR_PROPOSAL]: { Icon: HourglassTop, color: COLORS.WARNING },
  [APPLICATION_STATUS.PROPOSAL_READY]: { Icon: Receipt, color: COLORS.BLUE_DARK },
  [APPLICATION_STATUS.AWAITING_EXECUTOR_CONTACT]: { Icon: Pending, color: COLORS.WARNING },
  [APPLICATION_STATUS.AT_EXECUTOR]: { Icon: Work, color: COLORS.BLUE_DARK },
  [APPLICATION_STATUS.CLOSED]: { Icon: Lock, color: COLORS.GREEN },
}

const ApplicationStatusIcon = ({ status, label, muted = false, size = 24 }: ApplicationStatusIconProps) => {
  const { t } = useTranslation()

  const statusLabel = getApplicationStatusLabel({ status, fallback: label, translate: t })
  const presentation = STATUS_PRESENTATION[status as APPLICATION_STATUS]

  if (!presentation) {
    return <Typography variant='body2'>{statusLabel}</Typography>
  }

  const { Icon } = presentation
  const color = muted ? COLORS.LIGHT_TEXT_DISABLED : presentation.color

  return (
    <Tooltip title={<Typography variant='body2'>{statusLabel}</Typography>}>
      <Icon
        role='img'
        aria-label={statusLabel}
        width={size}
        height={size}
        style={{
          display: 'block',
          color,
          fill: color,
          flexShrink: 0,
        }}
      />
    </Tooltip>
  )
}

export default ApplicationStatusIcon
